
import {
  MqMinWidthTabletMedium,
  MqMinWidthTabletXlarge,
} from '@Tokens/tokens.json';
import { buildFixedSrcSet, buildFluidSrcSet, buildSrc } from '@Utils/images';

export default {
  name: 'EditoList',
  props: {
    /**
     * List images
     */
    images: {
      type: Array,
      default: undefined,
    },
    /**
     * List main image
     */
    img: {
      type: [Object, String],
      default: undefined,
    },
    /**
     * List items
     */
    items: {
      type: Array,
      default: undefined,
    },
  },
  computed: {
    imgList() {
      if (!this.img) {
        return undefined;
      }

      return {
        alt: '',
        height: 700,
        loading: 'lazy',
        sizes: `${MqMinWidthTabletXlarge} 45vw, ${MqMinWidthTabletMedium} 75vw, 95vw`,
        src: buildSrc({
          img: this.img,
          width: 408,
        }),
        srcset: buildFluidSrcSet({
          img: this.img,
          sizes: [364, 432, 728],
        }),
      };
    },
    imgListItems() {
      if (!this.images) {
        return undefined;
      }

      return this.images.map((img) => ({
        alt: '',
        height: '90',
        loading: 'lazy',
        role: 'presentation',
        src: buildSrc({
          img,
          width: 90,
        }),
        srcset: buildFixedSrcSet({
          img,
          width: 90,
        }),
        width: '90',
      }));
    },
  },
};
